module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('h5', [_vm._v("Dłużnik")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('autocomplete', {
    ref: "name",
    attrs: {
      "id": "_name",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByName,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 3,
      "onInput": _vm.setNameValue,
      "url": "test",
      "anchor": "name"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.name))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.nip)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_nip"
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('autocomplete', {
    ref: "nip",
    attrs: {
      "id": "_nip",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByNip,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 2,
      "onInput": _vm.setNipValue,
      "url": "test",
      "anchor": "nip"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.nip) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_nip_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.nip))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.regon)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_regon"
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('autocomplete', {
    ref: "regon",
    attrs: {
      "id": "_regon",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByRegon,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 2,
      "onInput": _vm.setRegonValue,
      "url": "test",
      "anchor": "regon"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.regon) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_regon_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.regon))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col col-md-6 has-error has-error"
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox1"
    },
    model: {
      value: (_vm.item.debtorData.cessionAvailable),
      callback: function($$v) {
        _vm.$set(_vm.item.debtorData, "cessionAvailable", $$v)
      },
      expression: "item.debtorData.cessionAvailable"
    }
  }, [_vm._v("\n                Cesja możliwa\n            ")])], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-4': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.street)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_street"
    }
  }, [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.debtorData.address.street),
      expression: "item.debtorData.address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_address_street"
    },
    domProps: {
      "value": (_vm.item.debtorData.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.debtorData.address, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.street) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_street_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.address.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-2': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_number"
    }
  }, [_vm._v("Numer domu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.debtorData.address.number),
      expression: "item.debtorData.address.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_address_number"
    },
    domProps: {
      "value": (_vm.item.debtorData.address.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.debtorData.address, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.address.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-2': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.postalCode)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_postal_code"
    }
  }, [_vm._v("Kod pocztowy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.debtorData.address.postalCode),
      expression: "item.debtorData.address.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_address_postal_code"
    },
    domProps: {
      "value": (_vm.item.debtorData.address.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.debtorData.address, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.postalCode) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_postal_code_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.address.postalCode))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-4': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.city)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Miasto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.debtorData.address.city),
      expression: "item.debtorData.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_address_city"
    },
    domProps: {
      "value": (_vm.item.debtorData.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.debtorData.address, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.address && _vm.errors.debtorData.address.city) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.address.city))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-12': true, 'has-error': (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.debtorData.comments),
      expression: "item.debtorData.comments"
    }],
    staticClass: "form-control full-width",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.debtorData.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.debtorData, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.debtorData && _vm.errors.debtorData.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.debtorData.comments))]) : _vm._e()])]), _vm._v(" "), _c('h5', [_vm._v(" Dane faktury")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_number"
    }
  }, [_vm._v("Numer faktury")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.number),
      expression: "item.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_number"
    },
    domProps: {
      "value": (_vm.item.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.amount)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_amount"
    }
  }, [_vm._v("Kwota")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.currencyName
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.amount),
      expression: "item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_amount"
    },
    domProps: {
      "value": (_vm.item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors && _vm.errors.amount) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_amount_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.createDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_createDate"
    }
  }, [_vm._v("Data wystawienia")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "id": "_createDate",
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.item.createDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "createDate", $$v)
      },
      expression: "item.createDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.createDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_createDate_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.createDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.paymentDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_paymentDate"
    }
  }, [_vm._v("Data płatności")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "id": "_paymentDate",
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.item.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "paymentDate", $$v)
      },
      expression: "item.paymentDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.paymentDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_paymentDate_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.paymentDate))]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7cccf38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/FormFactoredInvoice.vue
// module id = 836
// module chunks = 0